import styled from "styled-components";
import { Font, Color, ColorDark, breakpoints } from "@/shared/Constants";

export const BtnFollowGoogle = styled.a`
  border: 1px solid ${Color.grey};
  background-color: transparent;
  border-radius: 50px;
  max-width: fit-content;
  min-width: fit-content;
  display: flex;
  align-items: center;
  padding: 0.5rem 0.75rem;
  cursor: pointer;

  &.has-only-google-icon {
    display: flex !important;
    align-items: center;
    justify-content: center;
    min-width: 35px;
    height: 35px;
    padding: 0px;
    .img__icon-google {
      width: 16px;
      height: 16px;
    }
  }

  .follow-google__icon {
    margin-right: 4px;
    color:  ${Color.grey} !important;
    > div {
      height: 15px;
      margin-bottom: 2px;
    }

    ${breakpoints.darkMode} {
      [data-theme="dark"] & {
        color: ${Color.tertiaryColor} !important;
      }
    }
  }
  .follow-google__content {
    display: inline-flex;
    align-items: center;
    gap: 0.5rem;
  }
  .follow-google__text {
    ${Font.sansRegular};
    font-size: 14px;
    color: ${Color.grey};
    ${breakpoints.darkMode} {
      [data-theme="dark"] & {
        color: ${Color.tertiaryColor};
      }
    }
  }
  .img__icon-google {
    width: 18px;
    height: 18px;
    display: inline-block;
    flex-shrink: 0;
  }

  .img__logo-google {
    width: 18px;
    height: 18px;
    display: inline-block;
    flex-shrink: 0;
  }

  &.btn-add-google-header {
    flex-shrink: 0;

    ${breakpoints.phone} {
      padding: 0.4rem 0.6rem;

      .follow-google__icon {
        display: flex;
        align-items: center;
        justify-content: center;
        margin-right: 3px;
        line-height: 0;

        > div {
          display: flex;
          align-items: center;
          justify-content: center;
          height: auto;
          margin-bottom: 0;
        }

        svg {
          width: 13px;
          height: 13px;
        }
      }

      .follow-google__content {
        display: inline-flex;
        align-items: center;
        gap: 0.35rem;
      }

      .follow-google__text {
        font-size: 12px;
        line-height: 1.2;
      }

      .img__icon-google,
      .img__logo-google {
        width: 16px;
        height: 16px;
      }
    }
  }
`;
